import { branding } from "./branding";

export const TOAST_MESSAGES = {
  // Shared/Generic
  UNAUTHORIZED: "Session expired or unauthorized. Please log in again.",
  GENERAL_ERROR: "Something went wrong",

  // 🔒 Privacy or Settings
  PRIVACY_MODE_ON: "Switched to Full Privacy Mode",
  PRIVACY_MODE_OFF: "Switched to Zero Privacy Mode",
  SETTINGS_SAVED: "Settings saved successfully!",

  // Global error messages
  GLOBAL: {
    NO_INTERNET: "You're offline. Please check your internet connection.",
    BACK_ONLINE: "You're back online.",
    UNAUTHORIZED: "Session expired or unauthorized. Please log in again.",
    FORBIDDEN: "You are not authorized or account is inactive.",
    TOO_MANY_REQUESTS: "Too many requests. Please try again later.",
    SERVER_ERROR: "Server error. Please try again later.",
    MAINTENANCE: "System is under maintenance. Please try later.",
    REQUEST_TIMEOUT: "Request timed out. Please try again.",
    JS_ERROR: "An unexpected error occurred.",
    PROMISE_REJECTION: "An unexpected error occurred in a promise.",

    // Newly added messages
    VERSION_MISMATCH: "Your application version is outdated. Please refresh.",
    FORM_SUBMIT_ERROR: "Failed to submit form. Please try again.",
    CONFIG_ERROR: "Configuration missing or corrupted. Contact support.",
    DEPENDENCY_FAILURE: "Required resources failed to load. Try again later.",
    UNSUPPORTED_BROWSER:
      "Your browser is not supported. Please update or switch.",
    DB_UNAVAILABLE: "Database is temporarily unavailable. Try again later.",
    THIRD_PARTY_FAILURE: "A third-party service failed. Try again later.",
    UNSTABLE_CONNECTION: "Unstable connection. Please try again.",
  },

  // Model messages
  MODEL: {
    // Fetch / Generic
    FETCH_ERROR: "Failed to fetch models.",

    // Success messages
    ADD_SUCCESS: "Model added successfully.",
    UPDATE_SUCCESS: "Model updated successfully.",
    STATUS_UPDATE_SUCCESS: "Model status changed.",
    DOWNLOAD_SUCCESS: "Download triggered successfully.",

    // Error messages
    ADD_ERROR: "Failed to add model.",
    UPDATE_ERROR: "Failed to update model.",
    STATUS_UPDATE_ERROR: "Failed to change status.",
    STATUS_UPDATE_FAILED: "Unable to update model status. Please try again.",
    DOWNLOAD_ERROR: "Failed to trigger download.",
    FORM_SUBMIT_ERROR: "Something went wrong.",

    // Validation messages
    ID_REQUIRED: "Model ID cannot be empty.",
    ID_DUPLICATE: "This Model ID already exists.",
    NAME_REQUIRED: "Model name cannot be empty.",
    NAME_DUPLICATE: "A Model with this name already exists.",
    GENERIC_NAME_REQUIRED: branding("ZeroBox Model Name cannot be empty."),
    GENERIC_NAME_DUPLICATE: branding(
      "A ZeroBox Model with this name already exists.",
    ),
    DESCRIPTION_REQUIRED: "Model description cannot be empty.",

    // ✅ Status-specific messages
    STATUS_REJECTED: "This model has been rejected.",
    STATUS_APPROVED: "This model has been approved.",
    STATUS_IN_REVIEW: "This model is under review.",
    STATUS_UPDATE_FAILED: "Unable to update model status. Please try again.",
  },

  VERSION: {
    // ✅ Add this
    FETCH_ERROR: "Failed to fetch version history.",
    CREATE_SUCCESS: "Version created successfully.",
    CREATE_ERROR: "Failed to create version.",
    UPDATE_SUCCESS: "Version updated successfully.",
    UPDATE_ERROR: "Failed to update version.",
    STATUS_CHANGE_SUCCESS: "Version status changed successfully.",
    STATUS_CHANGE_ERROR: "Failed to change version status.",
  },

  WEBSITE_UPLOAD: {
    SUCCESS: "Website uploaded successfully!",
    ERROR: "Website upload failed.",
    EMPTY: "Please enter a valid website URL.",
  },

  UPLOAD: {
    SUCCESS: "Upload completed successfully.",
    FAILED: "Upload failed. Please try again.",
  },
  FILE: {
    SUCCESS: "File fetch successfully",
    FAILED: "Failed to fetch files.",
  },
  NOTIFICATION: {
    FETCH_ERROR: "Failed to fetch notifications.",
    MARK_READ_SUCCESS: "Notification marked as read.",
    MARK_READ_ERROR: "Failed to mark notification as read.",
    NO_NEW: "No new notifications.",
  },

  UPLOADED_DOCS: {
    APPROVE_SUCCESS: "Document approved successfully.",
    REJECT_SUCCESS: "Document rejected successfully.",
    ACTION_FAILED: "Failed to process your action.",
    FETCH_FAILED: "Failed to load uploaded documents.",
  },

  DOCUMENT_UPLOAD: {
    GLOBAL_SUCCESS:
      "Your document was successfully processed under Global mode.",
    PERSONAL_SUCCESS:
      "Your document was successfully processed under Personal mode.",
    INCOGNITO_SUCCESS:
      "Your document was successfully processed under Incognito mode.",
    // FAILED: "Document upload failed. Please try again.",
    FAILED: "Something went wrong during the upload. Please try again.",
    SELECT_FILE: "Please provide at least one file, URL, or Video video.",
  },

  DOCUMENT_HISTORY: {
    FETCH_FAILED: "Failed to load  history. Please try again later.",
    FETCH_SUCCESS: "Document history loaded successfully.",
  },

  YOUTUBE_HISTORY: {
    FETCH_FAILED: "Failed to load Video history. Please try again later.",
    FETCH_SUCCESS: "Video history loaded successfully.",
  },

  TEXT_UPLOAD: {
    SUCCESS: "Text uploaded successfully.",
    ERROR: "Failed to upload text.",
    EMPTY: "Please enter some text.",
  },

  URL_HISTORY: {
    FETCH_FAILED: "Failed to load URL history. Please try again later.",
    FETCH_SUCCESS: "URL history loaded successfully.",
  },

  QA_UPLOAD: {
    SUCCESS: "Q&A added successfully.",
    ERROR: "Failed to add Q&A.",
    EMPTY: "Please enter both question and answer.",
  },

  // Old Module messages
  // MODULE: {
  //   FETCH_ERROR: "Failed to fetch modules",
  //   CREATE_SUCCESS: "Module added successfully",
  //   CREATE_ERROR: "Failed to add module",
  //   UPDATE_SUCCESS: "Module updated successfully",
  //   UPDATE_ERROR: "Failed to update module",
  //   DELETE_SUCCESS: "Module deleted successfully",
  //   DELETE_ERROR: "Failed to delete module",
  //   STATUS_CHANGE_SUCCESS: "Module status changed",
  //   STATUS_CHANGE_ERROR: "Failed to change status",
  //   UNAUTHORIZED: "Session expired or unauthorized. Please log in again.",
  //   GENERAL_ERROR: "Something went wrong",
  // },

  MODULE: {
    FETCH_ERROR: "Failed to fetch modules",
    CREATE_SUCCESS: "Module added successfully.",
    CREATE_ERROR: "Failed to add module.",
    UPDATE_SUCCESS: "Module updated successfully.",
    UPDATE_ERROR: "Failed to update module.",
    DELETE_SUCCESS: "Module deleted successfully.",
    DELETE_ERROR: "Failed to delete module.",
    STATUS_CHANGE_SUCCESS: "Module status changed successfully.",
    STATUS_CHANGE_ERROR: "Failed to update module status. Please try again.",
    UNAUTHORIZED: "Session expired or unauthorized. Please log in again.",
    GENERAL_ERROR: "Something went wrong.",

    // 👇 Add this new toast message
    DUPLICATE_NAME_ERROR: "A module with this name already exists.",
    DUPLICATE_ORDER_ERROR: "This module order number already exists.",
  },

  PRODUCT: {
    FETCH_ERROR: "Failed to fetch products",
    CREATE_SUCCESS: "Product added successfully",
    CREATE_ERROR: "Failed to add product",
    UPDATE_SUCCESS: "Product updated successfully",
    UPDATE_ERROR: "Failed to update product",
    DELETE_SUCCESS: "Product deleted successfully",
    DELETE_ERROR: "Failed to delete product",
    STATUS_CHANGE_SUCCESS: "Product status changed",
    STATUS_CHANGE_ERROR: "Failed to change status",
  },

  ENTERPRISE: {
    FETCH_ERROR:
      "Unable to retrieve enterprize data. Please refresh or try again later.",
    CREATE_SUCCESS: "Enterprize added successfully",
    CREATE_ERROR: "Failed to add enterprise",
    UPDATE_SUCCESS: "Enterprize updated successfully",
    UPDATE_ERROR: "Failed to update enterprise",
    DELETE_SUCCESS: "Enterprize deleted successfully",
    DELETE_ERROR: "Failed to delete enterprise",
    STATUS_CHANGE_SUCCESS: "Enterprize status changed",
    STATUS_CHANGE_ERROR: "Failed to change status",
  },

  USER: {
    // ─────────────── CRUD STATUS ───────────────
    FETCH_ERROR: "Failed to fetch users.",
    CREATE_SUCCESS: "User added successfully.",
    CREATE_ERROR: "Failed to add user.",
    UPDATE_SUCCESS: "User updated successfully.",
    UPDATE_ERROR: "Failed to update user.",
    STATUS_CHANGE_SUCCESS: "User status changed successfully.",
    STATUS_CHANGE_ERROR: "Failed to change user status.",

    // ─────────────── VALIDATION ERRORS ───────────────
    REQUIRED_ENTERPRISE: "Please select an enterprise.",
    REQUIRED_ROLE: "Please select a role.",
    REQUIRED_NAME: "Name cannot be empty.",
    REQUIRED_EMAIL: "Email cannot be empty.",
    INVALID_EMAIL: "Please enter a valid email address.",
    REQUIRED_PASSWORD: "Password is required.",
    PASSWORD_LENGTH: "Password must be at least 6 characters long.",
    PASSWORD_CAPITAL: "Password must contain at least one capital letter.",
    PASSWORD_SPECIAL: "Password must contain at least one special character.",
    PASSWORD_MISMATCH: "Passwords do not match.",
    EMAIL_EXISTS: "This email is already registered.",
    USER_NOT_FOUND: "User not found.",
  },

  AUTH: {
    LOGIN_SUCCESS: "You're logged in.",
    LOGIN_FAILED:
      "The login details you entered are incorrect. Please try again.",
    NO_ROLE: "Role not assigned. Contact admin.",

    RESET_CODE_SENT: "Password reset email sent successfully!",
    RESET_EMAIL_FAILED: "Failed to send reset email. Please try again.",

    PASSWORD_TOO_SHORT: "Password must be at least 6 characters.",
    PASSWORD_NEEDS_UPPER:
      "Password must include at least one uppercase letter.",
    PASSWORD_NEEDS_SPECIAL: "Include at least one special character.",
    PASSWORDS_DO_NOT_MATCH: "Passwords do not match.",
    SESSION_EXPIRED: "Session expired. Please restart the process.",
    PASSWORD_RESET_SUCCESS: "Your password has been reset successfully!",
    PASSWORD_RESET_FAILED: "Password reset failed. Try again.",

    EMAIL_VERIFIED: "OTP verified successfully!",
    EMAIL_VERIFICATION_FAILED: "Invalid or expired OTP.",
    ENTER_FULL_OTP: "Please enter the full 6-digit code.",
  },

  ROLE: {
    FETCH_ERROR: "Failed to fetch roles",
    CREATE_SUCCESS: "Role added successfully.",
    CREATE_ERROR: "Failed to add role",
    UPDATE_SUCCESS: "Role updated successfully.",
    UPDATE_ERROR: "Failed to update role",
    DELETE_SUCCESS: "Role deleted successfully.",
    DELETE_ERROR: "Failed to delete role",
    STATUS_CHANGE_SUCCESS: "Role status changed",
    STATUS_CHANGE_ERROR: "Failed to change status",
    DUPLICATE_NAME_ERROR: "A role with this name already exists.", // ✅ Add this
  },

  ENTERPRISE_SETTINGS: {
    ORG_CREATE_SUCCESS: "Organization settings created successfully.",
    ORG_UPDATE_SUCCESS: "Organization settings updated successfully.",
    DISC_CREATE_SUCCESS: "Disclaimer created successfully.",
    DISC_UPDATE_SUCCESS: "Disclaimer updated successfully.",
    SAVE_ERROR: "Failed to save enterprise settings.",

    SUB_CREATE_SUCCESS: "Subscription created successfully.",
    SUB_UPDATE_SUCCESS: "Subscription updated successfully.",
    FETCH_SUBSCRIPTION_ERROR: "Failed to fetch subscription data.",
    FETCH_ORG_SETTINGS_ERROR: "Failed to fetch organization settings.",
    FETCH_DISCLAIMER_ERROR: "Failed to fetch disclaimer settings.",

    SAVE_SUCCESS: "Settings saved successfully.",
  },

  SUBSCRIPTION: {
    FETCH_ERROR: "Failed to fetch subscriptions.",
    CREATE_ERROR: "Failed to create subscription.",
    UPDATE_ERROR: "Failed to update subscription.",
    STATUS_CHANGE_ERROR: "Failed to change status.",
    STATUS_CHANGE_SUCCESS: "Subscription status changed",
    CREATE_SUCCESS: "Subscription created successfully.",
    UPDATE_SUCCESS: "Subscription updated successfully.",
  },

  PROFILE: {
    IMAGE_UPLOAD_SUCCESS: "Profile image updated!",
    IMAGE_UPLOAD_FAILED: "Image upload failed",
    IMAGE_TOO_LARGE: "Image size must be less than 1MB",
    SAVE_SUCCESS: "Changes saved successfully",
    SAVE_FAILED: "Failed to save changes",
    FETCH_FAILED: "Failed to load user profile",
  },
};
